module.exports = __webpack_public_path__ + "static/media/laura_danish.1b94044c.mp3";